import SolutionDepositCompleteContainer from 'containers/SolutionDepositCompleteContainer';
import React from 'react';

export default function SolutionDepositCompletePage() {
  return (
    <SolutionDepositCompleteContainer />
  )
}
